import React from 'react';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  type: 'text' | 'circle' | 'rectangle' | 'message' | 'suggestion' | 'header' | 'avatar' | 'input-wrapper';
  width?: string | number;
  height?: string | number;
  count?: number;
  style?: React.CSSProperties;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type,
  width,
  height,
  count = 1,
  style,
}) => {
  const renderSkeleton = () => {
    const skeletons = [];

    for (let i = 0; i < count; i++) {
      skeletons.push(
        <div 
          key={i}
          className={`skeleton-loader skeleton-${type}`}
          style={{ 
            width: width || 'auto', 
            height: height || 'auto',
            ...style
          }}
        />
      );
    }

    return skeletons;
  };

  return <>{renderSkeleton()}</>;
};

export default SkeletonLoader;
